import React, { useEffect, useState } from "react";
import Image from "../../../components/AppImage";
import Icon from "../../../components/AppIcon";

const motorImages = [
  "/assets/motor/produk/beat/Honda-Beat-Sporty-CBS-Hard-Rock-Black-1.webp",
  "/assets/motor/produk/stylo160/Stylo-160-ABS-Royal-Matte-Blue.webp",
  "/assets/motor/produk/adv/Honda-ADV-160-ABS-Tough-Matte-Black-1.webp",
  "/assets/motor/produk/vario160/New-Honda-Vario-160-ABS-Grande-Matte-White-300x300_c.webp",
];

const HeroSection = () => {
  const [show, setShow] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    setShow(true);
  }, []);

  // AUTO SLIDE – SATU IMAGE, FADE LEFT
  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // fade out dulu

      setTimeout(() => {
        setActiveIndex((prev) =>
          prev === motorImages.length - 1 ? 0 : prev + 1
        );
        setFade(true); // fade in image baru
      }, 300);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  const whatsappMessage = encodeURIComponent(
    "Hai, saya tertarik untuk membeli motor Honda. Mohon info lebih lanjut."
  );

  return (
    <section className="pt-12 mb-16 overflow-hidden">
      {/* ⬆️ FIX: kasih jarak aman dari header */}

      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">

          {/* ================= LEFT CTA ================= */}
          <div
            className={`max-w-xl transition-all duration-700 ease-out
              ${show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}
            `}
          >
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold leading-tight mb-4">
              <span className="text-primary">Pilihan Motor Honda Terbaik</span>
              <br />
              untuk Aktivitas Anda
            </h1>

            <p className="text-muted-foreground text-sm md:text-base mb-6">
              Temukan motor Honda dengan desain modern, mesin irit,
              dan performa handal untuk kebutuhan harian maupun perjalanan jauh.
            </p>

            <div className="flex flex-wrap gap-3 mb-8">
              <span className="px-4 py-2 rounded-full bg-muted text-sm">
                Mesin Irit & Bertenaga
              </span>
              <span className="px-4 py-2 rounded-full bg-muted text-sm">
                Desain Modern
              </span>
              <span className="px-4 py-2 rounded-full bg-muted text-sm">
                Dealer Resmi Honda
              </span>
            </div>

            <div className="flex gap-4">
              <a
                href={`https://wa.me/+6288293642972?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
                className="
                  inline-flex items-center gap-2
                  border border-primary text-primary
                  px-6 py-3 rounded-full
                  font-heading font-bold
                  transition-all duration-300
                  hover:bg-primary hover:text-white
                "
              >
                <Icon name="MessageCircle" size={18} />
                Info & Pemesanan
              </a>

              <a
                href="../../credit-simulation"
                className="
                  inline-flex items-center gap-2
                  px-6 py-3 rounded-full
                  border border-primary text-primary
                  font-semibold
                  transition-all duration-300
                  hover:bg-primary hover:text-white
                "
              >
                Cek Simulasi Kredit
              </a>
            </div>
          </div>

          {/* ================= RIGHT IMAGE (STABIL) ================= */}
          <div
            className={`relative flex justify-center transition-all duration-700 ease-out
              ${show ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}
            `}
          >
            {/* FIXED HEIGHT → NO LAYOUT SHIFT */}
            <div className="relative w-full max-w-xl h-[420px] -ml-8 flex items-center justify-center">
              <Image
                src={motorImages[activeIndex]}
                alt="Motor Honda"
                className={`
                  w-full h-full object-contain scale-115
                  transition-all duration-300 ease-in-out
                  ${fade ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-6"}
                `}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HeroSection;
